import {
    useCallback,
    useEffect,
    useRef,
    useState,
} from "react";

import {
    CircularProgress,
    TextField,
} from "@material-ui/core";

import Autocomplete from "@material-ui/lab/Autocomplete";

export default function DashboardFilter({
    filterKey,
    label,
    value,
    setFilters,
    fetchOptions,
    disabled = false,
}) {

    const requestIdRef = useRef(0);
    const [loading, setLoading] = useState(false);
    const [options, setOptions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [debouncedInput, setDebouncedInput] = useState("")

    const loadOptions = useCallback(
        async (search = "") => {

            const requestId = ++requestIdRef.current;
            setLoading(true);

            try {
                const data = await fetchOptions(search);
                if (requestId !== requestIdRef.current) {
                    return;
                }
                setOptions(data);
            } finally {
                if (requestId === requestIdRef.current) {
                    setLoading(false);
                }
                setLoading(false);
            }
        },
        [fetchOptions]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            setDebouncedInput(inputValue);
        }, 500);
        return () => clearTimeout(timeout);
    }, [inputValue]);

    useEffect(() => {
        if (
            debouncedInput &&
            debouncedInput.length < 3
        ) {
            return;
        }
        loadOptions(debouncedInput);
    }, [debouncedInput, loadOptions]);

    return (
        <Autocomplete
            disabled={disabled}
            options={options}
            loading={loading}
            value={value}
            inputValue={inputValue}
            getOptionLabel={(option) => option?.name || ""}
            getOptionSelected={(option, selected) => option.id === selected.id}
            onInputChange={(event, value) => {
                setInputValue(value);
            }}
            onChange={(event, selectedOption) => {
                setFilters(
                    (previous) => ({
                        ...previous,
                        [filterKey]: selectedOption ? selectedOption.id : null,
                    })
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    label={label}
                    size="small"
                    disabled={disabled}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && (<CircularProgress size={16} />)}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
        />
    );
}